import { createTheme } from "@mui/material/styles";

// Brand colors derived from logo.svg
// Navy: #013763  Red: #BF1E2D
const theme = createTheme({
  palette: {
    primary: {
      main: "#013763",
      light: "#1A5276",
      dark: "#012347",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#BF1E2D",
      light: "#D4434F",
      dark: "#9A1824",
      contrastText: "#FFFFFF",
    },
    success: {
      main: "#059669",
      light: "#10B981",
      dark: "#047857",
    },
    error: {
      main: "#DC2626",
      light: "#EF4444",
      dark: "#B91C1C",
    },
    warning: {
      main: "#D97706",
      light: "#F59E0B",
      dark: "#B45309",
    },
    info: {
      main: "#0284C7",
      light: "#0EA5E9",
      dark: "#0369A1",
    },
    background: {
      default: "#F7F8FA",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#0F172A",
      secondary: "#64748B",
    },
    divider: "#E2E8F0",
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    h1: { fontWeight: 700, letterSpacing: "-0.025em" },
    h2: { fontWeight: 700, letterSpacing: "-0.025em" },
    h3: { fontWeight: 600, letterSpacing: "-0.02em" },
    h4: { fontWeight: 600, letterSpacing: "-0.02em" },
    h5: { fontWeight: 600, letterSpacing: "-0.01em" },
    h6: { fontWeight: 600 },
    subtitle1: { fontWeight: 500 },
    subtitle2: { fontWeight: 500 },
    body1: { fontSize: "0.938rem", lineHeight: 1.6 },
    body2: { fontSize: "0.875rem", lineHeight: 1.5 },
    caption: { fontSize: "0.75rem", fontWeight: 500 },
    button: { fontWeight: 600, textTransform: "none", letterSpacing: "0.01em" },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          padding: "9px 20px",
          fontSize: "0.875rem",
          boxShadow: "none",
          "&:hover": { boxShadow: "none" },
        },
        contained: {
          "&:hover": {
            boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
          },
        },
        containedPrimary: {
          backgroundColor: "#013763",
          "&:hover": { backgroundColor: "#012347" },
        },
        containedSecondary: {
          backgroundColor: "#BF1E2D",
          "&:hover": { backgroundColor: "#9A1824" },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
          border: "1px solid #E2E8F0",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          fontWeight: 500,
          fontSize: "0.75rem",
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          height: 6,
          backgroundColor: "#F1F5F9",
        },
        barColorPrimary: {
          backgroundColor: "#013763",
        },
      },
    },
  },
});

export default theme;
